export default __webpack_public_path__ + "static/BrandonGrotesque-Thin-ebf6b1adc409d04ee8d6443d6858e8af.woff2";